import React from 'react';
import { UIHeading1, useDeviceType } from '@cian/ui-kit';

import { UIHeading0 } from '../../../../Typography/UIHeading0';

/**
 * Компонент заголовка
 */
export const Heading = () => {
  const deviceType = useDeviceType();
  const HeadingComponent = deviceType === 'desktop' ? UIHeading0 : UIHeading1;

  return <HeadingComponent>Рейтинг специалистов</HeadingComponent>;
};
